import { cn } from '@zealot/ui/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import type * as React from 'react';

const pageLayoutVariants = cva(
  'flex flex-col overflow-hidden rounded-lg border border-border text-card-foreground shadow-sm',
  {
    variants: {
      variant: {
        default: '',
        'full-width': 'rounded-none border-x-0 shadow-none',
        sidebar: '',
      },
      surface: {
        card: 'bg-card',
        canvas: 'bg-canvas',
      },
    },
    defaultVariants: {
      variant: 'default',
      surface: 'card',
    },
  },
);

const PageLayout = ({
  className,
  variant = 'default',
  surface = 'card',
  ...props
}: React.ComponentProps<'div'> & VariantProps<typeof pageLayoutVariants>) => {
  return (
    <div
      data-slot="page-layout"
      data-variant={variant}
      data-surface={surface}
      className={cn(pageLayoutVariants({ variant, surface, className }))}
      {...props}
    />
  );
};

const PageLayoutHeader = ({ className, ...props }: React.ComponentProps<'div'>) => {
  return <div data-slot="page-layout-header" className={cn(className)} {...props} />;
};

const PageLayoutContent = ({ className, ...props }: React.ComponentProps<'div'>) => {
  return <div data-slot="page-layout-content" className={cn('min-h-0 flex-1 overflow-auto', className)} {...props} />;
};

const PageLayoutSidebar = ({ className, ...props }: React.ComponentProps<'aside'>) => {
  return (
    <aside
      data-slot="page-layout-sidebar"
      className={cn('w-72 shrink-0 overflow-auto border-border border-l', className)}
      {...props}
    />
  );
};

export { PageLayout, PageLayoutContent, PageLayoutHeader, PageLayoutSidebar, pageLayoutVariants };
